export enum DataRequestStatus {
    downloadFailed = 'downloadFailed',
    failed = 'failed',
    inProgress = 'inProgress',
    open = 'open',
    processed = 'processed',
}
